export default {"src":"/_next/static/media/plus_icon.ba0fbe4d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};